module.exports = __webpack_public_path__ + "img/news_home_3.b946fe00.jpg";